var GoogleTagManager = /** @class */ (function () {
    function GoogleTagManager() {
    }
    GoogleTagManager.prototype.send = function (data) {
        if (typeof window !== "undefined") {
            window.lp.analytics.dataLayer.push(data);
        }
    };
    return GoogleTagManager;
}());
export { GoogleTagManager };



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-analytics/dist-es/providers/gtm.js
// module id = QmVb
// module chunks = 2